import { isRunningInBrowser } from "../components/App";
import { DocumentView } from "../helpers/Models";
import { objectToURLParams } from "../helpers/api-helpers";
import { backendEndpoint, environment } from "../utils/constants";

const url_get_document = backendEndpoint[environment] + "/doc/{slug_and_opinion_id}";

export const getDocument = async ({
  opinionId,
  sessionId,
  getToken,
}: {
  getToken: () => Promise<string | null>;
  opinionId: string;
  sessionId?: string;
}) => {
  try {
    const token = await getToken();
    if (!isRunningInBrowser() && (!sessionId || !token)) {
      console.error("getDocument -- sessionId or token is missing");
      return;
    }

    const headers: Record<string, string> = {};
    headers["Authorization"] = `Bearer ${token}`;

    const path = url_get_document.replace("{slug_and_opinion_id}", opinionId);

    const data = {
      session_id: sessionId,
      citation_count: false,
    };
    const urlWithParams = `${path}?${objectToURLParams(data)}`;

    const res = await fetch(urlWithParams, {
      method: "GET",
      headers: headers,
    });

    const doc: DocumentView = await res?.json();
    return doc;
  } catch (error) {
    console.error("useDocument -- getDocument error", error);
  }
};
